/*-----------------------------------------------------------------
- Seo translations
-----------------------------------------------------------------*/
export default {
    other_locales: 'Other Locales',
    edit         : 'Edit',
    view         : 'View on site',
};
